import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import { login_success } from '../../../actions/user';
import './style.scss';
import { userType } from '../../../models/type.model';
import Html from './Html';
import { useNavigate } from 'react-router-dom';
import formModel from '../../../models/form.model';
import { toast } from 'react-toastify';
import environment from '../../../environment';
import axios from 'axios';

const EditProfile = () => {
  const user = useSelector((state: any) => state.user);
  const [data, setData] = useState('');
  const [loading, setLoading] = useState(false);
  const [RemoveImage, setRemoveImage] = useState('')
  const [form, setForm]: any = useState(userType);
  const dispatch = useDispatch();
  const history = useNavigate()
  const [submitted, setSubmitted] = useState(false)

  const [images, setImages]: any = useState({ image: '' });
  const gallaryData = () => {
    loader(true)
    ApiClient.get(`admin/profile`, { id: user._id }).then(res => {
      if (res.success) {
        let payload = form
        let value = res.data
        let oarr = Object.keys(form)
        oarr.map(itm => {
          payload[itm] = value[itm] || null
        })
        setForm({ form, ...res.data, role: res.data.role.name })
        let img = images

        Object.keys(images).map(itm => {
          img[itm] = value[itm]
        })
        setImages({ ...img })
        setData(value)
      }
      loader(false)
    })
  };

  const getError = (key: any) => {
    return formModel.getError('profileForm', key)
  }

  const handleSubmit = (e: any) => {


    e.preventDefault();
    setSubmitted(true)
    let invalid = formModel.getFormError('profileForm')
    if (invalid) return

    let value = { firstName: form.firstName, lastName: form?.lastName, mobileNo: form?.mobileNo, image: form?.image, id: user?.id, dialCode: form?.dialCode }
    if (form?.mobileNo.length < 10) {
      return
    }
    loader(true)
    ApiClient.put('admin/profile', value).then(res => {
      if (res.success) {
        let uUser = { ...user, ...value }
        dispatch(login_success(uUser))
        loader(false);

        if (RemoveImage) {
          remove(RemoveImage)
        }
        history('/profile')

      }
      loader(false);

    })

  };
  const remove = (url: any) => {
    // loader(true);
    // ApiClient.azureBlobDelete({ fileName: value }).then((res) => {
    //   loader(false);

    ApiClient.delete(`delete/image?modelName=users&Imagename=${url}`).then(
      (res) => {
        if (res?.success) {
          ApiClient.put('admin/profile', { image: '', id: form?.id })
          // setForm({ ...form, image: '' })
          setRemoveImage("")
        } else {
          // setForm({ ...form, image: '' })

        }
      }
    );

    // });
  };
  const imageResult = (e: any, key: any) => {
    images[key] = e.value
    setImages(images)
    console.log("imageResult", e)
  }

  const uploadImage = async (e: any) => {
    console.log(e.target.files?.length, '========uploadImage')
    if (e.target.files?.length < 1) {
      return
    }
    loader(true)


    setForm({ ...form, baseImg: e.target.value })


    let files = e.target.files;
    let file = files.item(0);
    let formData = new FormData();
    formData.append('file', file);
    const res = await axios.post(
      `${environment.api}upload/image?modelName=users`,
      formData
    );
    //   const res = await ApiClient.postFormData('upload/image?modelName=users', {
    //     file: file,
    //   });
    if (res?.data?.success) {
      let image = res?.data?.data?.fullpath;
      loader(false)
      if (RemoveImage) {

        remove(RemoveImage)
      }
      setForm({ ...form, image: res?.data?.data?.fullpath })



    }
    loader(false)

  }

  useEffect(
    () => {
      if (user && user.loggedIn) {
        gallaryData();
        let forms: any = document.forms
        let field = forms['profileForm'].elements['fullName']

      }
    }, []);

  return (
    <>
      <Html
        handleSubmit={handleSubmit}
        setForm={setForm}
        form={form}
        imageResult={imageResult}
        images={images}
        uploadImage={uploadImage}
        getError={getError}
        history={history}
        submitted={submitted}
        remove={remove}
        setRemoveImage={setRemoveImage}
        RemoveImage={RemoveImage}
      // fileInputRef = {fileInputRef}

      />
    </>
  );
};

export default EditProfile;
